(function () {
  var RETRY_DELAYS = [0, 50, 150, 400, 800, 1500];
  var FALLBACK_MARKER = 'ciw-la-contact-upload-fallback';
  var pendingFallbackTimerIds = [];
  var uploadFallbackSessionActive = false;
  var uploadFallbackSuppressed = false;
  var MQ_MOBILE_UPLOAD = window.matchMedia('(max-width: 749px)');

  function isSubmissionStepVisible() {
    var submissionScope = document.querySelector('.la-prescription-wrapper:not(form)');
    if (!submissionScope || submissionScope.hasAttribute('hidden')) return false;
    var style = window.getComputedStyle(submissionScope);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    return submissionScope.getClientRects().length > 0;
  }

  function isUploadFallbackAllowed() {
    if (!isContactHost() || !document.body.classList.contains('la-modal-open')) return false;
    if (uploadFallbackSuppressed) return false;
    if (!uploadFallbackSessionActive) return false;
    if (isSubmissionStepVisible()) {
      uploadFallbackSessionActive = false;
      return false;
    }
    return true;
  }

  function cancelContactUploadFallbackRetries() {
    pendingFallbackTimerIds.forEach(function (id) {
      window.clearTimeout(id);
    });
    pendingFallbackTimerIds = [];
    uploadFallbackSessionActive = false;
    uploadFallbackSuppressed = true;
  }

  function isContactHost() {
    return window.ciwLaHostApi ? window.ciwLaHostApi.isContactLens() : !!document.querySelector('.cl-section');
  }

  function isMobileUpload() {
    return MQ_MOBILE_UPLOAD.matches;
  }

  function hideContactUploadContentBodyForEnhance() {
    if (!isMobileUpload()) return;
    var contentBody =
      getContentBody(window.LensAdvizor) ||
      document.querySelector('#lensadvizor-prescription-modal .la-prescription-modal-content-body');
    if (!contentBody) return;
    contentBody.style.setProperty('visibility', 'hidden', 'important');
    contentBody.setAttribute('data-ciw-la-contact-upload-pending', '1');
  }

  function revealContactUploadContentBodyAfterEnhance(body) {
    if (!isMobileUpload()) return;
    body = body || getContentBody(window.LensAdvizor);
    if (!body || body.getAttribute('data-ciw-la-contact-upload-pending') !== '1') return;
    if (!uploadDomReady(body)) return;
    body.style.removeProperty('visibility');
    body.removeAttribute('data-ciw-la-contact-upload-pending');
  }

  function clearContactUploadContentBodyPendingHide() {
    var contentBody = document.querySelector(
      '#lensadvizor-prescription-modal .la-prescription-modal-content-body[data-ciw-la-contact-upload-pending]'
    );
    if (!contentBody) return;
    contentBody.style.removeProperty('visibility');
    contentBody.removeAttribute('data-ciw-la-contact-upload-pending');
  }

  function getContentBody(la) {
    return (la && la.contentBox) || document.querySelector('.la-prescription-modal-content-body');
  }

  function uploadDomReady(body) {
    if (!body) return false;
    return !!body.querySelector('#la-prescription-form .la-upload-wrapper, #la-prescription-form #la-prescription-file');
  }

  function unmountBrokenIractRoot(body) {
    if (!body || !body._iractRoot) return;
    try {
      if (typeof body._iractRoot.unmount === 'function') {
        body._iractRoot.unmount();
      }
    } catch (err) {}
    delete body._iractRoot;
  }

  var UPLOAD_ICON_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none" aria-hidden="true">' +
    '<rect x="8" y="6" width="24" height="28" rx="2" stroke="currentColor" stroke-width="1.75"/>' +
    '<path d="M14 14h12M14 19h12M14 24h7" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/>' +
    '<path d="M28 10l4 4-4 4" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M24 14h8" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/>' +
    '</svg>';

  function syncContactUploadFileState(dropZone, fileInput, statusEl, browseLabel) {
    if (!dropZone || !fileInput) return;

    var file = fileInput.files && fileInput.files[0];
    if (file) {
      dropZone.classList.add('ciw-la-upload-drop-zone--has-file');
      if (statusEl) {
        statusEl.hidden = false;
        statusEl.textContent = file.name;
      }
      if (browseLabel) {
        browseLabel.textContent = 'Change file';
      }
      return;
    }

    dropZone.classList.remove('ciw-la-upload-drop-zone--has-file');
    if (statusEl) {
      statusEl.hidden = true;
      statusEl.textContent = '';
    }
    if (browseLabel) {
      browseLabel.textContent = 'Browse files';
    }
  }

  function bindContactUploadDropZone(dropZone, fileInput, la) {
    if (!dropZone || !fileInput || dropZone.dataset.ciwLaContactUploadBound === '1') return;

    dropZone.dataset.ciwLaContactUploadBound = '1';

    var browseLabel = dropZone.querySelector('.ciw-la-upload-drop-zone__browse');
    var statusEl = dropZone.querySelector('.ciw-la-upload-drop-zone__status');

    function openFilePicker() {
      fileInput.click();
    }

    function handleFiles(fileList) {
      if (!fileList || !fileList.length) return;

      try {
        if (typeof DataTransfer !== 'undefined') {
          var transfer = new DataTransfer();
          transfer.items.add(fileList[0]);
          fileInput.files = transfer.files;
        }
      } catch (err) {}

      syncContactUploadFileState(dropZone, fileInput, statusEl, browseLabel);

      if (typeof la.handlePrescriptionUpload === 'function') {
        la.handlePrescriptionUpload();
      }
    }

    dropZone.addEventListener('click', function (event) {
      if (event.target.closest('.ciw-la-upload-drop-zone__browse')) return;
      openFilePicker();
    });

    dropZone.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      if (event.target.closest('.ciw-la-upload-drop-zone__browse')) return;
      event.preventDefault();
      openFilePicker();
    });

    ['dragenter', 'dragover'].forEach(function (type) {
      dropZone.addEventListener(type, function (event) {
        event.preventDefault();
        event.stopPropagation();
        dropZone.classList.add('ciw-la-upload-drop-zone--dragover');
      });
    });

    ['dragleave', 'drop'].forEach(function (type) {
      dropZone.addEventListener(type, function (event) {
        event.preventDefault();
        event.stopPropagation();
        dropZone.classList.remove('ciw-la-upload-drop-zone--dragover');
      });
    });

    dropZone.addEventListener('drop', function (event) {
      var files = event.dataTransfer && event.dataTransfer.files;
      handleFiles(files);
    });

    fileInput.addEventListener('change', function () {
      syncContactUploadFileState(dropZone, fileInput, statusEl, browseLabel);
      if (fileInput.files && fileInput.files.length && typeof la.handlePrescriptionUpload === 'function') {
        la.handlePrescriptionUpload();
      }
    });

    syncContactUploadFileState(dropZone, fileInput, statusEl, browseLabel);
  }

  function buildContactUploadFallback(la, body) {
    if (!la || !body || uploadDomReady(body)) return false;
    if (body.querySelector('#la-prescription-form.' + FALLBACK_MARKER)) {
      revealContactUploadContentBodyAfterEnhance(body);
      return true;
    }

    unmountBrokenIractRoot(body);

    var form = document.createElement('form');
    form.id = 'la-prescription-form';
    form.className = 'la-prescription-wrapper ' + FALLBACK_MARKER + ' ciw-la-contact-upload-form--mobile ciw-la-upload-rx-form--mobile';
    form.style.marginBottom = '3rem';

    var heading = document.createElement('div');
    heading.className = 'ciw-la-manual-rx-heading ciw-la-upload-rx-heading';
    var title = document.createElement('h3');
    title.className = 'ciw-la-manual-rx-heading__title';
    title.id = 'la_prescriptionSelect_title';
    title.textContent = 'Upload your prescription';
    heading.appendChild(title);

    var card = document.createElement('div');
    card.className = 'ciw-la-manual-rx-card ciw-la-manual-rx-card--mobile ciw-la-upload-rx-card';

    var uploadWrap = document.createElement('div');
    uploadWrap.className = 'la-upload-wrapper ciw-la-upload-rx-section--file';

    var dropZone = document.createElement('div');
    dropZone.className = 'ciw-la-upload-drop-zone';
    dropZone.setAttribute('role', 'button');
    dropZone.setAttribute('tabindex', '0');
    dropZone.setAttribute('aria-describedby', 'file-help');

    var icon = document.createElement('span');
    icon.className = 'ciw-la-upload-drop-zone__icon';
    icon.innerHTML = UPLOAD_ICON_SVG;

    var lead = document.createElement('p');
    lead.className = 'ciw-la-upload-drop-zone__lead';
    lead.textContent = 'Drag and drop your prescription here';

    var orText = document.createElement('p');
    orText.className = 'ciw-la-upload-drop-zone__or';
    orText.textContent = 'or';

    var fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.id = 'la-prescription-file';
    fileInput.name = 'la-prescription-file';
    fileInput.className = 'la-hidden';
    fileInput.accept = 'image/*,image/avif,image/webp,application/pdf';
    fileInput.required = true;
    fileInput.setAttribute('aria-describedby', 'file-help');

    var fileLabel = document.createElement('label');
    fileLabel.htmlFor = 'la-prescription-file';
    fileLabel.className = 'ciw-la-upload-drop-zone__browse la-label-btn';
    fileLabel.textContent = 'Browse files';

    var help = document.createElement('p');
    help.id = 'file-help';
    help.className = 'ciw-la-upload-drop-zone__hint la-information';
    help.textContent = 'PNG, JPG or PDF';

    var status = document.createElement('p');
    status.className = 'ciw-la-upload-drop-zone__status';
    status.setAttribute('aria-live', 'polite');
    status.hidden = true;

    dropZone.appendChild(icon);
    dropZone.appendChild(lead);
    dropZone.appendChild(orText);
    dropZone.appendChild(fileInput);
    dropZone.appendChild(fileLabel);
    dropZone.appendChild(help);
    dropZone.appendChild(status);

    uploadWrap.appendChild(dropZone);
    card.appendChild(uploadWrap);

    var confirmRow = document.createElement('div');
    confirmRow.className =
      'ciw-la-manual-rx-confirm-row ciw-la-contact-upload-confirm-row la-prescription-fields-wrapper';
    confirmRow.dataset.ciwLaFallbackConfirm = '1';

    var confirmLabel = document.createElement('label');
    confirmLabel.className = 'la-form-field-label la-checkox-wrapper-label';
    confirmLabel.htmlFor = 'la-upload-confirmation';

    var confirmInput = document.createElement('input');
    confirmInput.type = 'checkbox';
    confirmInput.id = 'la-upload-confirmation';
    confirmInput.name = 'la-upload-confirmation';
    confirmInput.required = true;

    var confirmText = document.createElement('span');
    confirmText.className = 'ciw-la-manual-rx-confirm-text';
    confirmText.textContent =
      'By clicking this box, I confirm that the prescription values entered above are taken from a valid (not expired) prescription issued to me, signed by a licensed optometrist or ophthalmologist.';

    confirmLabel.appendChild(confirmInput);
    confirmLabel.appendChild(confirmText);
    confirmRow.appendChild(confirmLabel);
    card.appendChild(confirmRow);

    form.appendChild(heading);
    form.appendChild(card);

    body.innerHTML = '';
    body.appendChild(form);

    bindContactUploadDropZone(dropZone, fileInput, la);
    bindContactUploadFooterSubmit(form, la);

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }
      if (la.response) {
        la.response.manually = la.response.manually || {};
      }
      if (typeof la.renderReview === 'function') {
        la.renderReview();
      }
    });

    if (typeof la.updateFormBtnState === 'function') {
      la.updateFormBtnState(form.checkValidity());
    }

    var contentBody = body.closest('.la-prescription-modal-content-body') || body;
    contentBody.classList.add('ciw-la-upload-rx-step--mobile');
    setUploadStepActive(true);

    document.dispatchEvent(new CustomEvent('ciw-la-contact-upload:enhanced'));
    syncContactUploadFooter(la, form);
    revealContactUploadContentBodyAfterEnhance(body);
    return true;
  }

  function syncContactUploadFooter(la, form) {
    form = form || document.querySelector('#la-prescription-form.ciw-la-contact-upload-form--mobile');
    if (!form) return;

    if (typeof la.updateFormBtnState === 'function') {
      la.updateFormBtnState(form.checkValidity());
    }

    document.dispatchEvent(new CustomEvent('ciw-la-contact-rx:footer-sync'));
  }

  function bindContactUploadFooterSubmit(form, la) {
    if (!form || form.dataset.ciwLaContactUploadFooterBound === '1') return;
    form.dataset.ciwLaContactUploadFooterBound = '1';

    form.addEventListener('change', function () {
      syncContactUploadFooter(la, form);
    });
  }

  function bindContactUploadFooterButton() {
    if (document.documentElement.dataset.ciwLaContactUploadFooterBtn === '1') return;
    document.documentElement.dataset.ciwLaContactUploadFooterBtn = '1';

    document.addEventListener(
      'click',
      function (event) {
        var btn = event.target && event.target.closest ? event.target.closest('.la-prescription-form-btn') : null;
        if (!btn || !btn.closest('.la-prescription-modal-footer')) return;
        var activeForm = document.querySelector('#la-prescription-form.ciw-la-contact-upload-form--mobile');
        if (!activeForm) return;

        event.preventDefault();
        event.stopPropagation();
        if (typeof activeForm.requestSubmit === 'function') {
          activeForm.requestSubmit();
        } else {
          activeForm.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        }
      },
      true
    );
  }

  function ensureContactUploadFallback(la) {
    la = la || window.LensAdvizor;
    if (!la || !la.isContactLensFlow || !document.body.classList.contains('la-modal-open')) return false;
    if (!isUploadFallbackAllowed()) return false;

    var body = getContentBody(la);
    if (!body) return false;
    if (uploadDomReady(body)) {
      revealContactUploadContentBodyAfterEnhance(body);
      return false;
    }

    return buildContactUploadFallback(la, body);
  }

  function scheduleContactUploadFallback(la) {
    uploadFallbackSuppressed = false;
    uploadFallbackSessionActive = true;

    pendingFallbackTimerIds.forEach(function (id) {
      window.clearTimeout(id);
    });
    pendingFallbackTimerIds = [];

    RETRY_DELAYS.forEach(function (delay) {
      var timerId = window.setTimeout(function () {
        ensureContactUploadFallback(la || window.LensAdvizor);
      }, delay);
      pendingFallbackTimerIds.push(timerId);
    });
  }

  function patchLensAdvizorContactUploadRender() {
    var la = window.LensAdvizor;
    if (!la || typeof la.renderUploadForm !== 'function') return false;
    if (la.__ciwClUploadRenderPatched) return true;

    la.__ciwClUploadRenderPatched = true;

    var original = la.renderUploadForm.bind(la);
    la.renderUploadForm = function () {
      if (this.isContactLensFlow && this.options && !this.options.fieldValues) {
        this.options.fieldValues = { ocularHeight: [], segmentHeight: [], pd: [] };
      }

      var self = this;
      try {
        original.apply(this, arguments);
      } catch (err) {
        console.error('CIW contact upload: LensAdvizor renderUploadForm failed', err);
      }

      scheduleContactUploadFallback(self);
    };

    return true;
  }

  function handleUploadStep() {
    if (window.ciwLaContactStepMark) {
      window.ciwLaContactStepMark('upload');
    }
    scheduleContactUploadFallback(window.LensAdvizor);
  }

  function setUploadStepActive(active) {
    var isActive = !!active;
    var modal = document.getElementById('lensadvizor-prescription-modal');
    document.body.classList.toggle('ciw-la-upload-step-active', isActive);
    if (modal) {
      modal.classList.toggle('ciw-la-upload-step-active', isActive);
    }
  }

  function teardownContactUploadStepOnNavigateBack() {
    if (!MQ_MOBILE_UPLOAD.matches) return;

    setUploadStepActive(false);
    var contentBody = document.querySelector(
      '#lensadvizor-prescription-modal .la-prescription-modal-content-body'
    );
    if (contentBody) {
      contentBody.classList.remove('ciw-la-upload-rx-step--mobile');
    }

    var form = document.querySelector('#la-prescription-form');
    if (form) {
      form.classList.remove('ciw-la-contact-upload-form--mobile', 'ciw-la-upload-rx-form--mobile');
      form.style.removeProperty('margin-bottom');
    }
  }

  function bind() {
    if (!isContactHost()) return;

    bindContactUploadFooterButton();

    document.addEventListener(
      'click',
      function (event) {
        if (!isContactHost() || !document.body.classList.contains('la-modal-open')) return;
        if (!event.target.closest('.ciw-la-contact-back-btn, .la-steeper-back:not(:disabled)')) return;
        cancelContactUploadFallbackRetries();
      },
      true
    );

    document.addEventListener('LensAdvizor:selectLensModal:close', function () {
      cancelContactUploadFallbackRetries();
      clearContactUploadContentBodyPendingHide();
    });

    document.addEventListener('LensAdvizor:render:submissionMethods', function () {
      teardownContactUploadStepOnNavigateBack();
    });

    var patchTimer = window.setInterval(function () {
      if (patchLensAdvizorContactUploadRender()) {
        window.clearInterval(patchTimer);
      }
    }, 250);
    window.setTimeout(function () {
      window.clearInterval(patchTimer);
    }, 15000);

    document.addEventListener('LensAdvizor:render:uploadForm', function () {
      hideContactUploadContentBodyForEnhance();
      handleUploadStep();
    });
    document.addEventListener('LensAdvizor:component:DidMount', function (event) {
      var detail = event && event.detail ? event.detail : {};
      if (detail.method === 'renderUploadForm') {
        handleUploadStep();
      }
    });

    document.addEventListener('click', function (event) {
      if (
        event.target.closest(
          'label[for="submission-type-0"], #submission-type-0, .la-submission-type-0, [data-submission-type="upload"], [data-submission-type="uploaded"], .la-submission-type-upload'
        )
      ) {
        window.setTimeout(handleUploadStep, 0);
        window.setTimeout(handleUploadStep, 300);
      }
    });
  }

  window.ciwLaContactUploadEnhance = function () {
    scheduleContactUploadFallback(window.LensAdvizor);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
